const loadmoreItems = document.querySelectorAll("[data-loadmore-item]");
const loadmoreButton = document.querySelector("[data-loadmore-button]");

document.addEventListener("DOMContentLoaded", () => {
    let amountOfInitialItems;

    if (document.documentElement.clientWidth <= 576) {
        amountOfInitialItems = 3;
    } else {
        amountOfInitialItems = 8;
    }

    loadmoreItems.forEach((item, index, arr) => {
        if (index < amountOfInitialItems) item.classList.remove("_hidden");
        if (index === arr.length - 1 && arr.length > amountOfInitialItems) {
            item.classList.remove("_hidden");
        } else if (index === arr.length - 1) {
            item.classList.add("_hidden");
        }
    });
});

loadmoreButton?.addEventListener("click", () => {
    const loadmoreHiddenItems = document.querySelectorAll(
        "[data-loadmore-item]._hidden"
    );
    if (document.documentElement.clientWidth <= 576) {
        for (let i = 0; i < 3; i++) {
            const item = loadmoreHiddenItems[i];
            if (item) {
                item.classList.remove("_hidden");
            }
            if (i === loadmoreHiddenItems.length - 1) {
                loadmoreButton
                    .closest("[data-loadmore-item]")
                    ?.classList.add("_hidden");
                return;
            }
        }
    } else {
        loadmoreHiddenItems.forEach((item) => {
            item.classList.remove("_hidden");
            loadmoreButton
                .closest("[data-loadmore-item]")
                ?.classList.add("_hidden");
        });
    }
});
